module.exports = __webpack_public_path__ + "static/media/macbook-black.d98cd84e.png";